import * as React from "react";
import { forwardRef } from "react";
const SvgTextContains = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.33203 2.5V5.83333H4.9987V4.16667H9.16536V15.8333H7.4987V17.5H12.4987V15.8333H10.832V4.16667H14.9987V5.83333H16.6654V2.5H3.33203Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgTextContains);
export default ForwardRef;
